import { render, staticRenderFns } from "./UploadedFile.vue?vue&type=template&id=0b11d6c8&scoped=true"
import script from "./UploadedFile.vue?vue&type=script&lang=js"
export * from "./UploadedFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11d6c8",
  null
  
)

export default component.exports